import {hashCode, hex2rgb} from "./commonUtils";
import * as d3 from "d3";

// colores usados por Google en sus graficos, trends, etc.
export function colores_google(n) {
    const colores_g = ["#3366cc", "#dc3912", "#ff9900", "#109618", "#990099", "#0099c6", "#dd4477", "#66aa00", "#b82e2e", "#316395", "#994499", "#22aa99", "#aaaa11", "#6633cc", "#e67300", "#8b0707", "#651067", "#329262", "#5574a6", "#3b3eac"];
    return colores_g[n % colores_g.length];
}

//Taken from http://bl.ocks.org/mbostock/7555321
//Wraps SVG text
export function wrapText(text, width) {
    text.each(function () {
        const text = d3.select(this);
        const words = text.text().split(/\s+/).reverse();
        let word;
        let line = [];
        let lineNumber = 0;
        const lineHeight = 1.4;
        const y = text.attr("y");
        const x = text.attr("x");
        const dy = parseFloat(text.attr("dy"));
        let tspan = text.text(null).append("tspan").attr("x", x).attr("y", y).attr("dy", dy + "em");

        while (word = words.pop()) {
            line.push(word);
            tspan.text(line.join(" "));
            if (tspan.node().getComputedTextLength() > width) {
                line.pop();
                tspan.text(line.join(" "));
                line = [word];
                tspan = text.append("tspan").attr("x", x).attr("y", y).attr("dy", ++lineNumber * lineHeight + dy + "em").text(word);
            }
        }
    });
}


export function centerTranslate(element, width, height, margin) {
    return element.append("g")
        .attr("transform", "translate(" + (width / 2 + margin.left) + "," + (height / 2 + margin.top) + ")");
}

export function createSvgElementWithMargin(idContainer, width, height, margin, cssClass) {
    //Remove whatever chart with the same id/class was present before
    d3.select('#' + idContainer).select("svg").remove();

    //Initiate the radar chart SVG
    const svg = d3.select('#' + idContainer).append("svg")
        .attr("width", width + margin.left + margin.right)
        .attr("height", height + margin.top + margin.bottom);

    if (cssClass) svg.attr("class", cssClass);

    //Append a g element
    const g = svg.append("g")
        .attr("transform", "translate(" + (width / 2 + margin.left) + "," + (height / 2 + margin.top) + ")");

    return svg;
}

export function getGoogleColorByString(str) {
    return colores_google(hashCode(str));
}

export function getGoogleRGBAColorByString(str) {
    const rgbColor = hex2rgb(getGoogleColorByString(str));
    return [rgbColor.r, rgbColor.g, rgbColor.b, 255];
}

export function nFormatter(num, digits) {
    const si = [
        {value: 1, symbol: ""},
        {value: 1E3, symbol: "k"},
        {value: 1E6, symbol: "M"},
        {value: 1E9, symbol: "G"},
        {value: 1E12, symbol: "T"},
        {value: 1E15, symbol: "P"},
        {value: 1E18, symbol: "E"}
    ];
    const rx = /\.0+$|(\.[0-9]*[1-9])0+$/;
    let i;
    for (i = si.length - 1; i > 0; i--) if (num >= si[i].value) break;
    return (num / si[i].value).toFixed(digits).replace(rx, "$1") + si[i].symbol;
}

export function wrap(text, width, height) {
    text.each(function () {
        let text = d3.select(this);
        let fontSize = Number.parseFloat(text.style("font-size")) || 14;
        let step = getStep(text.style("font-size"));
        text.style("font-size", fontSize + "px");
        let fontRatio = 0;
        let ratio = 0;
        do {  //очень сильное колдунство
            ratio = Math.ceil(text.node().getComputedTextLength() / (width - 10));
            let textHeight = text.node().getBBox().height;
            fontRatio = height / (ratio * textHeight * 1.1);
            if (fontRatio < 1) {
                fontSize -= step;
                text.style("font-size", fontSize + 'px');
            }
        } while (fontRatio < 1);
        if (ratio > 1) {
            let str = text.text();
            text.text(null);
            let lng = Math.ceil(str.length / ratio);
            let dy = parseFloat(text.attr("dy"));
            let y = text.attr("y");
            let x = text.attr("x");
            for (let i = 0; i < ratio; i++) {
                let cut = str.slice(0, lng);
                str = str.slice(lng);
                text.append("tspan").attr("x", x).attr("y", y).attr("dy", countDy(i, ratio) + "em").text(cut);
            }
        }
    });

    function countDy(i, ratio) {
        if (ratio % 2 === 0) {
            let halfr = ratio / 2;
            return i < halfr ? (i + 1 - halfr) * (1.1) - .05 : (i - halfr) * 1.1 + 1.15;
        }
        let midIdx = Math.floor(ratio / 2);
        return i < midIdx ? -0.75 + (i + 1 - midIdx) * (1.1) : i === midIdx ? 0.35 : 0.35 + (i - midIdx) * 1.1;
    }

    function getStep(val) {
        let str = val.toString();
        return str.endsWith("px") ? 1 : str.endsWith("em") ? .1 : str.endsWith("%") ? 2 : str.endsWith("pt") ? 1 : 1;
    }
}